import React from 'react';

function Tabs({ activeTab, setActiveTab }) {
  const tabs = [
    { id: 'announcements', label: 'Announcements' },
    { id: 'current-issues', label: 'Current Issues' },
    { id: 'most-read', label: 'Most Read Articles' },
    { id: 'journals', label: 'Journals' },
    { id: 'books', label: 'Books' },
    { id: 'events', label: 'Events' }
  ];

  return (
    <div className="tabs">
      {tabs.map(tab => (
        <button
          key={tab.id}
          className={`tab-btn ${activeTab === tab.id ? 'active' : ''}`}
          onClick={() => setActiveTab(tab.id)}
        >
          {tab.label}
        </button>
      ))}
    </div>
  );
}

export default Tabs;
